import { Grid, Typography, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(() => ({
  textFormatted: {
    whiteSpace: "pre-line"
  }
}));

const ExpertProfileTab = ({ expert }) => {
  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="body2" className={classes.textFormatted}>
          {expert.description}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ExpertProfileTab;
